// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"AttendeeCard_cardImage__oy1Fp","cardMain":"AttendeeCard_cardMain__wAo_P","cardTitle":"AttendeeCard_cardTitle__TWJnS"};